// 来源，用于日志上报
export const UploadSource = {
    LOCAL: 1, // 本地
    ONLINE: 2, // 在线
};
